import { Box } from '@mui/material';
import CustomButton from '@ui-components/Button/CustomButton';
import { useNavigate } from 'react-router-dom';
import {
  CASEMANGER_CONSULT_REQUEST_DASHBOARD_ROUTE_PATH,
  FACILITY_CONSULT_REQUEST_DASHBOARD_ROUTE_PATH,
} from '../../routers/RoutPath';
import { getUserFromStorage } from '../components/storageUtility';
import { ROLES } from '../../roles';
import CustomTypography from '@qler-view/shared_lib/src/shared/lib/ui-components/Typography/CustomTypography';

export default function AccessDenied() {
  const navigate = useNavigate();
  const user = getUserFromStorage();
  const handleUserDashboard = () => {
    if (!user?.role) return;
    if (user.role === ROLES.FACILITY_USER) {
      navigate(FACILITY_CONSULT_REQUEST_DASHBOARD_ROUTE_PATH, {
        replace: true,
      });
    } else if (user.role === ROLES.CASE_MANAGER) {
      navigate(CASEMANGER_CONSULT_REQUEST_DASHBOARD_ROUTE_PATH, {
        replace: true,
      });
    }
  };
  return (
    <Box className="default-page mt-32">
      <CustomTypography id="link-expire-title" variant="h3" className="pb-12">
        Access Denied
      </CustomTypography>
      <CustomTypography
        id="link-expire-message"
        variant="body2"
        color="textSecondary"
        className="pb-32"
      >
        You are not authorized to use this system. Please contact your
        administrator.
      </CustomTypography>
      <Box className="mt-24">
        <CustomButton
          id="logout"
          variant="contained"
          size="large"
          onClick={() => handleUserDashboard()}
        >
          Back To Dashboard
        </CustomButton>
      </Box>
    </Box>
  );
}
